<!-- App Header - Fixed top bar -->
<app-header
  logoUrl="../../../assets/gokuri_logo_bk.svg"
  [userName]="loginUser.loginUserName ?? ''"
  [userRole]="loginUserJob || 'システム管理者'"
  [showHamburger]="true"
  [showHelp]="false"
  [sidenavCollapsed]="isSidenavCollapsed()"
  (hamburgerClick)="toggleSelf()"
  (logoutClick)="logout()"
  (themeToggle)="toggleTheme()">
  <!-- Workspace selector in header - static, no dropdown (section-select style matching home-nav) -->
  <div workspaceSelector class="section-select section-select--static">
    <div class="section-select__trigger">
      <mat-icon class="trigger-icon">admin_panel_settings</mat-icon>
      <span class="trigger-name" i18n="@@adminSystem.nav.workspace.systemAdmin">システム管理</span>
    </div>
  </div>
  <!-- Profile menu items -->
  @if (administeredSectionGroupId != null) {
    <button profileMenuItems mat-menu-item (click)="openNewWindow('/section-group-admin/' + administeredSectionGroupId + '/home')">
      <mat-icon>domain</mat-icon>
      <span i18n="@@adminSystem.nav.profileMenu.groupAdmin">グループ管理</span>
    </button>
  }
  @if (firstSectionId != null) {
    <button profileMenuItems mat-menu-item (click)="openNewWindow('/section-admin/' + firstSectionId)">
      <mat-icon>assignment_ind</mat-icon>
      <span i18n="@@adminSystem.nav.profileMenu.staffMenu">スタッフメニュー</span>
    </button>
  }
</app-header>

<mat-sidenav-container class="mat-sidenav-container" [class.sidenav-collapsed]="isSidenavCollapsed()" autosize>
  <mat-sidenav #drawer class="mat-sidenav" [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="!(isHandset$ | async) && IsNavSystemOpen === true">

    <div class="sidenav">
      <div class="sidenav-main">
        <div class="sidenav-content-panel">
          <!-- Menu -->
          <div class="sidenav-section">
            <h3 class="sidenav-section__title" i18n="@@adminSystem.nav.section.menu">メニュー</h3>
            <div class="sidenav-menu-items">
              
              <div class="side_menu_item domain">
                @if (true) {
                  <a [routerLink]="['/system-admin', 'section-groups']"
                    routerLinkActive="selected">
                    <mat-icon fontSet="material-icons-outlined">corporate_fare</mat-icon>
                    <span i18n="@@adminSystem.nav.menu.sectionGroupList">セクショングループ</span>
                  </a>
                }
              </div>

              <div class="side_menu_item summary-template">
                @if (common.hasParameterUpdate()) {
                  <a [routerLink]="['/system-admin', 'user-data-template']"
                    routerLinkActive="selected">
                    <mat-icon fontSet="material-icons-outlined">description</mat-icon>
                    <span i18n="@@adminSystem.nav.menu.userDataTemplate">定型ユーザーデータ</span>
                  </a>
                }
              </div>

              <div class="side_menu_item data-usage">
                @if (yearOfPrevMonth != null) {
                  <a [routerLink]="['/system-admin', 'monthly-summaries', yearOfPrevMonth, monthOfPrevMonth]"
                    routerLinkActive="selected">
                    <mat-icon fontSet="material-icons-outlined">storage</mat-icon>
                    <span i18n="@@adminSystem.nav.menu.monthlySummary">データ利用量</span>
                  </a>
                }
              </div>

              <div class="side_menu_item domain">
                @if (common.hasDistributorManagement() || common.hasAnyDistributorAgentRole()) {
                  <a [routerLink]="['/system-admin', 'distributors']"
                    routerLinkActive="selected">
                    <mat-icon fontSet="material-icons-outlined">corporate_fare</mat-icon>
                    <span i18n="@@adminSystem.nav.menu.distributorList">代理店</span>
                  </a>
                }
              </div>

            </div>
          </div>

          <!-- Settings -->
          <div class="sidenav-section">
            <h3 class="sidenav-section__title" i18n="@@adminSystem.nav.section.settings">設定</h3>
            <div class="sidenav-menu-items">
              <div class="side_menu_item admin_panel">
                @if (common.hasSystemAdminManagement()) {
                  <a [routerLink]="['/system-admin', 'admins']"
                     routerLinkActive="selected">
                    <mat-icon fontSet="material-icons-outlined">manage_accounts</mat-icon>
                    <span i18n="@@adminSystem.nav.menu.systemAdminList">システム管理者</span>
                  </a>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer (hidden when collapsed) -->
      @if (!isSidenavCollapsed()) {
        <div class="sidenav-footer">
          <span class="sidenav-footer__text">© {{ year }} PLIMES Inc.</span>
        </div>
      }
    </div>
  </mat-sidenav>

  <mat-sidenav-content class="mat-sidenav-content">
    <div class="main-content-area">
      <!-- Contents inside the main screen -->
      @if (error) {
        <div style="background-color: pink; font-size: 0.9em; color: darkred; font-weight: bold;">
          <div style="padding: 5px 5px 5px 5px;"> {{ errorText }} </div>
        </div>
      }
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
<!-- ------------------------------------------------------- -->
